// Add your custom JS here.
jQuery(function($){
    $(window).scroll(function () {
        if($(window).scrollTop() > 70) {
        $('#main-nav').addClass('nav-scrolled');
        } else {
        $('#main-nav').removeClass('nav-scrolled');
        }
    });


    $('#hero').attr('data-bs-ride','true');
});
